var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.5C25.5 11.4285 24.66 9.5535 23.304 8.1975C21.9465 6.84 20.0715 6 18 6C15.9285 6 14.0535 6.84 12.696 8.1975C11.34 9.5535 10.5 11.4285 10.5 13.5C10.5 15.5715 11.34 17.4465 12.696 18.8025C14.0535 20.16 15.9285 21 18 21C20.0715 21 21.9465 20.16 23.304 18.8025C24.0013 18.1069 24.5542 17.2803 24.9311 16.3704C25.308 15.4604 25.5013 14.4849 25.5 13.5ZM9 28.5C9 30 12.375 31.5 18 31.5C23.277 31.5 27 30 27 28.5C27 25.5 23.469 22.5 18 22.5C12.375 22.5 9 25.5 9 28.5Z",
    fill: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.523d4a2d16471fa7b5371423dd4b2283.svg";
export { ForwardRef as ReactComponent };